<template>
    <div>
        <v-img class="mb-10" :src="computedSrc" max-height="100" contain></v-img>
    </div>
</template>

<script>
export default {
  name: "CompanyLogo",
  computed: {
    computedSrc() {
      return process.env.NODE_ENV === 'development' ? '/img/monpatrol.png' : '/static/img/logo.png';
    }
  }
};
</script>

<style scoped>
</style>
